<div class="signin-wrapper">
  <form class="signin-form">
    <div style="width: 30%; margin-left: 40px; background: linear-gradient(#4309c2,#1d035b,#1D035BFF);">
      @if (email !== null && !inOperation) {
        <div style="position: relative;">
          <h1 class="header">Password Change</h1>
          <h3 style="color: white; width: 300px; margin-left: 22%">
            Hello, {{ email }}
            {{title}}<br>
            Please type your new password
          </h3>
          <div class="form-group">
            <div class="password">
              <mat-card-content>
                <mat-form-field appearance="outline" style="width: 100%;" [color]="passwordComponentWithConfirmation.color">
                  <mat-pass-toggle-visibility #toggle1 matSuffix></mat-pass-toggle-visibility>
                  <mat-label>Password</mat-label>
                  <input matInput id="password1" #password1 [type]="toggle1.type" placeholder="Password"
                    [formControl]="passwordComponentWithConfirmation.passwordFormControl" ngModel
                    (focusout)="currentField=''">
                  <mat-hint align="end" aria-live="polite">
                    {{password1.value.length}} / {{passwordComponentWithConfirmation.max}}
                  </mat-hint>
                </mat-form-field>
                <mat-password-strength #passwordComponentWithConfirmation class="green"
                  [min]="8"
                  [max]="20"
                  [password]="password1.value">
                </mat-password-strength>
                @if (password1.value && currentField === 'password1') {
                  <mat-password-strength-info
                    [passwordComponent]="passwordComponentWithConfirmation">
                  </mat-password-strength-info>
                }
              </mat-card-content>
            </div>
            <br>
              <div class="password">
                <mat-card-content>
                  <mat-form-field appearance="outline" style="width: 100%;" [color]="passwordComponent2.color">
                    <mat-pass-toggle-visibility #toggle2 matSuffix></mat-pass-toggle-visibility>
                    <mat-label>Confirm Password</mat-label>
                    <input matInput id="password2" #password2 [type]="toggle2.type" placeholder="Password"
                      [formControl]="passwordComponentWithConfirmation.passwordConfirmationFormControl"
                      (focusout)="currentField=''">
                    <mat-hint align="end" aria-live="polite">
                      {{password2.value.length}} / {{passwordComponent2.max}}
                    </mat-hint>
                  </mat-form-field>
                  <mat-password-strength #passwordComponent2 class="green"
                    [min]="8"
                    [max]="20"
                    [password]="password2.value">
                  </mat-password-strength>
                  @if (password2.value && currentField === 'password2') {
                    <mat-password-strength-info
                      [passwordComponent]="passwordComponent2">
                    </mat-password-strength-info>
                  }
                  @if (password1.value.length >0 && passwordComponentWithConfirmation.passwordFormControl.valid &&
                    passwordComponentWithConfirmation.passwordConfirmationFormControl.hasError('required')) {
                    <mat-error>
                      Password confirmation is required
                    </mat-error>
      }
                  @if (currentField === 'password2' && password1.value.length >0 && password2.value.length >0 &&
                    passwordComponentWithConfirmation.passwordFormControl.valid &&
                    passwordComponentWithConfirmation.passwordConfirmationFormControl.hasError('notConfirmed')) {
                    <mat-error>
                      Password value is not the same as first password
                    </mat-error>
                  }
                </mat-card-content>
              </div>
              <br>
              </div>
              @if (generalService.capsLock) {
                <div class="action-error">
                  WARNING! Caps lock is ON.
                </div>
              }
              <button class="submit" type="submit" (click)="password1.value=''" style="float: left; margin-left: 5%;">Cancel</button>
              <button [disabled]="password1.value === null || password1.value !== password2.value"
                class="submit" type="submit" (click)="onReset(password1.value)"
                style="float: right; margin-right: 6%;">Update Password
              </button>
            </div>
          }
          @if (inOperation) {
            <div>
              <h1 style="margin-top: 50px; color: white; font-size: 33.3px; font-weight: bold; width: 250px;">Please wait</h1>
            </div>
          }
        </div>
        <img class="login-pic" src="../../../assets/target-icons/login_background1.jpg" alt="">
      </form>
    </div>
